export enum Anchor {
  Top = "top",
  Bottom = "bottom",
  Start = "start",
  End = "end",
  Left = "left",
  Right = "right",
  Center = "center",
  BottomRight = "bottom right",
  LeftBottom = "left bottom",
}
